<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-select
          v-model="state.params.withholding_agent_id"
          placeholder="扣缴义务人"
          style="width: 300px"
          popper-class="taxdeclare-record-select"
        >
          <el-option
            v-for="item in state.withholding_agent_data"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadWithholdingAgent()">
              刷新
            </el-button>
          </template>
        </el-select>
        <el-select
          v-model="state.params.tax_bureau_id"
          placeholder="税局"
          style="width: 300px"
          popper-class="taxdeclare-record-select"
        >
          <el-option
            v-for="item in state.taxbureau_data"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadCustomer()">刷新</el-button>
          </template>
        </el-select>
        <el-input
          v-model="state.params.keywords"
          style="width: 200px"
          placeholder="姓名、证件号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        size="large"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="name"
          sortable="name"
          label="姓名"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
        />
        <el-table-column
          prop="idcard"
          label="证件号"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
          :min-width="140"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
          :min-width="160"
        />
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
          :min-width="160"
        />
        <el-table-column
          prop="income_amount"
          sortable="income_amount"
          label="本期收入总额"
          :formatter="$tab_PriceFormat"
          align="center"
        />
        <el-table-column
          prop="payable_tax_amount"
          sortable="payable_tax_amount"
          label="累计应扣缴纳"
          :formatter="$tab_PriceFormat"
          align="center"
        />
        <el-table-column
          prop="paied_tax_amount"
          sortable="paied_tax_amount"
          label="累计已扣缴额"
          :formatter="$tab_PriceFormat"
          align="center"
        />
        <el-table-column
          prop="tax_refund_amount"
          sortable="tax_refund_amount"
          label="本期应补(退)税额"
          :formatter="$tab_PriceFormat"
          align="center"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  data_withholdingagent_select,
  data_taxbureau_select,
} from "@/http/data";
import { taxdeclare_getemployee } from "@/http/taxdeclare";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
  };
}
export default {
  props: {
    tax_declare_id: Number,
    tax_declare_type_stat_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.tax_declare_id = props.tax_declare_id;
      state.params.tax_declare_type_stat_id = props.tax_declare_type_stat_id;

      onLoadWithholdingAgent();
      onLoadTaxBureau();
      onLoad();
    });

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      taxdeclare_getemployee(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoadWithholdingAgent,
      onLoadTaxBureau,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style>
.taxdeclare-record-select {
  z-index: 99999 !important;
}
</style>
